module.exports = __webpack_public_path__ + "img/江大寧律師.403b459c.jpg";